// extracted by mini-css-extract-plugin
module.exports = {"backIcon":"svg-module--backIcon--3YFyZ"};